{
  "appBarTitle": "Nhắn tin",
  "permissionDenied": "Bạn không có quyền dùng chat nội bộ.",
  "list": {
    "search": "Tìm hội thoại hoặc đồng nghiệp",
    "newGroup": "Tạo nhóm",
    "empty": "Tìm đồng nghiệp ở ô tìm kiếm rồi bấm vào để chat.",
    "noResults": "Không tìm thấy hội thoại hoặc đồng nghiệp.",
    "noPreview": "Chưa có tin nhắn",
    "sectionChats": "Hội thoại",
    "sectionPeople": "Đồng nghiệp",
    "startChat": "Nhắn tin",
    "filterAll": "Tất cả",
    "filterUnread": "Chưa đọc",
    "filterMentioned": "Tag tôi",
    "emptyUnread": "Không có hội thoại chưa đọc.",
    "emptyMentioned": "Không có hội thoại nào tag bạn."
  },
  "avatar": {
    "upload": "Tải ảnh nhóm",
    "change": "Đổi ảnh nhóm",
    "cropTitle": "Cắt ảnh nhóm",
    "cropHint": "Kéo để căn vùng hiển thị. Ảnh sẽ được lưu dạng vuông.",
    "cropZoom": "Thu phóng",
    "cropCancel": "Hủy",
    "cropConfirm": "Lưu ảnh",
    "remove": "Xóa ảnh",
    "uploadSuccess": "Đã cập nhật ảnh nhóm",
    "uploadFailed": "Không thể tải ảnh lên",
    "removeSuccess": "Đã xóa ảnh nhóm",
    "removeFailed": "Không thể xóa ảnh nhóm"
  },
  "new": {
    "group": "Tạo nhóm",
    "groupTitle": "Tên nhóm",
    "groupTitlePlaceholder": "Nhập tên nhóm...",
    "searchPeople": "Tìm đồng nghiệp",
    "createGroup": "Tạo nhóm",
    "creatingGroup": "Đang tạo nhóm...",
    "titleRequired": "Nhập tên nhóm",
    "minMembers": "Chọn ít nhất 2 người",
    "maxMembers": "Nhóm tối đa {{max}} thành viên, gồm cả bạn"
  },
  "thread": {
    "pick": "Chọn một hội thoại để bắt đầu",
    "empty": "Chưa có tin nhắn. Gửi tin để bắt đầu.",
    "loading": "Đang tải tin nhắn…",
    "loadOlder": "Kéo lên để xem tin cũ hơn",
    "loadingOlder": "Đang tải tin cũ…",
    "deleted": "Tin nhắn đã được thu hồi",
    "delete": "Thu hồi",
    "more": "Thêm",
    "edit": "Chỉnh sửa",
    "copy": "Sao chép",
    "reply": "Trả lời",
    "edited": "Đã sửa",
    "editHistory": "Lịch sử chỉnh sửa",
    "editHistoryCurrent": "Hiện tại",
    "editHistoryOriginal": "Bản gốc",
    "editHistoryEmpty": "Không có lịch sử chỉnh sửa.",
    "editHistoryLoadFailed": "Không tải được lịch sử chỉnh sửa.",
    "copyDone": "Đã sao chép",
    "copyFailed": "Không sao chép được.",
    "search": "Tìm trong hội thoại",
    "searchPlaceholder": "Tìm tin nhắn",
    "searchEmpty": "Không có tin khớp.",
    "searchClose": "Đóng tìm kiếm",
    "jumpMention": "Nhảy tới tin nhắc tên",
    "noMention": "Không có tin nhắc tên bạn.",
    "seen": "Đã xem",
    "seenCount": "{{count}} đã xem",
    "sent": "Đã gửi",
    "mute": "Tắt thông báo",
    "unmute": "Bật thông báo",
    "pin": "Ghim hội thoại",
    "unpin": "Bỏ ghim",
    "createTask": "Tạo việc",
    "entityDenied": "Không xem được"
  },
  "taskFrom": {
    "fileTitle": "Việc từ file: {{name}}",
    "source": "— Từ tin của {{author}} trong {{thread}}, {{time}}"
  },
  "presence": {
    "online": "Đang hoạt động",
    "typing": "{{name}} đang gõ…",
    "typingMany": "{{names}} đang gõ…"
  },
  "composer": {
    "placeholder": "Gõ @ để nhắc tên. Shift + Enter cho dòng mới.",
    "mention": "Nhắc tên",
    "mentionEmpty": "Không có thành viên khớp.",
    "mentionAllHint": "Nhắc tất cả thành viên",
    "send": "Gửi",
    "sendWithShortcut": "Gửi ({{shortcut}})",
    "attach": "Đính kèm",
    "emoji": "Emoji",
    "emojiSearch": "Tìm emoji",
    "expand": "Mở rộng khung soạn",
    "collapse": "Thu nhỏ khung soạn",
    "editing": "Chỉnh sửa tin nhắn",
    "replying": "Đang trả lời {{name}}",
    "save": "Lưu",
    "cancel": "Hủy",
    "attachEntity": "Gắn hồ sơ",
    "entitySearch": "Tìm bệnh nhân, lịch hẹn hoặc lead",
    "entityEmpty": "Không có kết quả.",
    "entityLimit": "Tối đa {{count}} hồ sơ mỗi tin.",
    "fileRejectedType": "Không hỗ trợ loại tệp: {{name}}",
    "fileTooLarge": "{{name}} vượt giới hạn {{maxMb}}MB",
    "fileLimit": "Tối đa {{max}} tệp mỗi tin nhắn",
    "voiceRecord": "Ghi âm",
    "voiceRecording": "Đang ghi {{time}}",
    "voiceRecordingPlaceholder": "Đang ghi âm…",
    "voiceStop": "Dừng và đính kèm",
    "voiceCancel": "Hủy ghi âm",
    "voiceTooShort": "Ghi âm quá ngắn.",
    "voicePermissionDenied": "Không truy cập được micro. Hãy cho phép quyền micro trên trình duyệt.",
    "voiceMaxDuration": "Đã dừng ghi âm vì đạt giới hạn thời lượng.",
    "entity": {
      "patient": "Bệnh nhân",
      "appointment": "Lịch hẹn",
      "lead": "Lead"
    }
  },
  "members": {
    "title": "Thành viên",
    "groupTitle": "Thành viên nhóm",
    "count": "{{count}} người",
    "countLabel": "{{count}} thành viên",
    "owner": "Trưởng nhóm",
    "you": "Bạn",
    "message": "Nhắn tin",
    "add": "Thêm thành viên",
    "search": "Tìm người để thêm",
    "remove": "Xóa khỏi nhóm",
    "leave": "Rời nhóm",
    "rename": "Tên nhóm",
    "editName": "Sửa tên nhóm",
    "saveName": "Lưu tên",
    "empty": "Chưa có thành viên.",
    "emptyAdd": "Không có đồng nghiệp để thêm.",
    "dialogClose": "Đóng"
  },
  "info": {
    "title": "Thông tin hội thoại",
    "open": "Thông tin",
    "close": "Đóng thông tin hội thoại",
    "designation": "Chức danh",
    "staffCode": "Mã nhân sự",
    "clinics": "Chi nhánh",
    "owner": "Trưởng nhóm",
    "memberCount": "Số thành viên",
    "openStaff": "Mở hồ sơ nhân sự",
    "noStaffRecord": "Không có hồ sơ nhân sự gắn với tài khoản này.",
    "noStaffPermission": "Bạn không có quyền xem hồ sơ nhân sự.",
    "emptyValue": "Không có",
    "files": "Ảnh & tệp",
    "sectionTitleWithCount": "{{title}} ({{count}})",
    "filesEmpty": "Chưa có tệp trong hội thoại này.",
    "filesMore": "Đang hiện các tệp mới nhất.",
    "filesAll": "Đã hiện toàn bộ tệp trong hội thoại.",
    "tasks": "Việc từ hội thoại",
    "tasksEmpty": "Chưa có việc tạo từ hội thoại này.",
    "tasksDenied": "Bạn không có quyền xem công việc.",
    "tasksMore": "Xem thêm"
  },
  "toasts": {
    "createFailed": "Không tạo được hội thoại.",
    "sendFailed": "Không gửi được tin nhắn.",
    "deleteFailed": "Không xóa được tin nhắn.",
    "membersFailed": "Không cập nhật được thành viên.",
    "renameFailed": "Không đổi được tên nhóm.",
    "avatarFailed": "Không cập nhật được ảnh nhóm.",
    "loadFailed": "Không tải được tin nhắn.",
    "editFailed": "Không sửa được tin nhắn.",
    "prefsFailed": "Không cập nhật được hội thoại."
  }
}
